<template>
  <v-card class="my-5">
    <v-card-title>
      Manuscript Communications

      <v-spacer></v-spacer>

      <v-btn
        depressed
        small
        v-if="current"
        color="blue lighten-4"
        @click="show = !show"
      >
        Compose
        <v-icon>
          {{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <div class="mb-1 px-4" v-if="show && current">
      <!-- <v-divider></v-divider> -->
      <v-form
        class="pb-4"
        ref="communicationForm"
        @submit.prevent="sendCommunication"
        v-model="communicationFormValid"
      >
        <v-text-field
          outlined
          hide-details
          class="mb-3"
          label="Subject *"
          :rules="rules.required"
          v-model="subject"
        ></v-text-field>
        <small>
          <label class="mt-5" for="communicationBody">
            Please do not start body with salutation
          </label>
        </small>
        <vue-pell-editor
          v-model="body"
          class="mb-2"
          id="communicationBody"
          :actions="editorOptions"
          :style-with-css="false"
          default-paragraph-separator="p"
          placeholder="Type or paste here.."
        />

        <v-file-input
          outlined
          show-size
          hide-details
          class="mb-4"
          v-model="attachment"
          label="Attachment"
          :rules="rules.attachment"
          :accept="wordPDFOrZip"
          prepend-icon="mdi-file-document"
        ></v-file-input>

        <div class="mt-5">
          <v-btn
            large
            type="submit"
            class="mr-2 white--text"
            color="blue accent-3"
            :disabled="sending || !communicationFormValid || !body"
            :loading="sending"
          >
            Send to {{ author ? "Editors" : "Authors" }}
            <v-icon right>mdi-send</v-icon>
          </v-btn>
          <v-btn
            text
            large
            color="red"
            @click="$refs.communicationForm.reset()"
          >
            Discard <v-icon right> mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </v-form>
      <v-divider v-if="communications.length > 0" class="mb-4"></v-divider>
    </div>
    <div :class="communications.length > 0 ? 'pb-3' : ''">
      <Communication
        class="mx-3"
        :class="index != 0 ? 'mt-3' : ''"
        :author="author"
        :communication="communication"
        :key="communication._id"
        @refresh="fetchCommunications"
        v-for="(communication, index) in communications"
      />
    </div>
  </v-card>
</template>

<script>
import dedent from "dedent";
import Communication from "./Communication";
import { editorOptions } from "../../../tools/wysiwyg";
import { required, abstract } from "../../../tools/rules";

export default {
  props: {
    manuscript: { type: String },
    author: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    show: false,
    sending: false,
    loading: false,

    subject: null,
    body: null,
    bodyOutput: null,
    attachment: null,

    editorOptions,

    communicationFormValid: false,
    communications: [],
    rules: {
      required,
      requiredAbstract: [...required, ...abstract],
    },
    wordPDFOrZip:
      "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed",
  }),

  components: {
    Communication,
  },
  methods: {
    fetchCommunications() {
      this.loading = true;
      this.$axios
        .get(`/communications/${this.manuscript}`)
        .then(({ data: response }) => {
          this.communications = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve communications",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendCommunication() {
      if (!this.sending) {
        this.sending = true;

        let formData = new FormData();
        formData.append("manuscript", this.manuscript);
        formData.append("subject", this.subject);
        this.author && formData.append("type", "AUTHOR");

        formData.append("body", this.cleanReviewText(this.body));

        this.attachment && formData.append("attachment", this.attachment);

        this.$axios
          .post(`/communications/${this.manuscript}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            this.fetchCommunications();
            this.$bus.$emit("snackbar", {
              type: "success",
              message: "Communication sent",
            });
            this.body = null;
            this.$refs.communicationForm.reset();
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not send communication",
            });
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    cleanReviewText(text) {
      return dedent(text.replace(/style="(.*?)" /g, ""));
    },
  },

  mounted() {
    this.fetchCommunications();
  },
};
</script>

<style>
</style>